import type { GetFlagArchiveChecksOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export interface GetFlagArchiveChecksQueryParams extends Omit<
  GetFlagArchiveChecksOpenAPIQueryParams,
  'environmentKeys'
> {
  environmentKeys?: string[];
}

export function querySerializer(params: GetFlagArchiveChecksQueryParams) {
  const searchParams = new URLSearchParams();

  if (params.expandDetails) {
    searchParams.set('expandDetails', 'true');
  }

  if (params.environmentKeys && params.environmentKeys.length > 0) {
    searchParams.set('environmentKeys', params.environmentKeys.join(','));
  }

  return searchParams.toString();
}
